import { render, staticRenderFns } from "./mheader.vue?vue&type=template&id=edc586d6&scoped=true"
import script from "./mheader.vue?vue&type=script&lang=js"
export * from "./mheader.vue?vue&type=script&lang=js"
import style0 from "./mheader.vue?vue&type=style&index=0&id=edc586d6&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc586d6",
  null
  
)

export default component.exports